import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { DashboardSidebar } from '@/layouts/dashboard';
import { useNavigate } from 'react-router-dom';
import { StepperWrapper } from '@/components/custom/stepper';
import { ButtonBack, ButtonBackContent } from '@/components/ui/button';
import { IconWrapper } from '@/components/custom/icon';
import { FilterTitle } from '@/components/custom/filter';

export default function ProjectSidebar(props) {
  const navigate = useNavigate();
  const { steps, currentStep } = props;

  return (
    <DashboardSidebar
      hasBrand={false}
      viewMode="create"
    >
      <ButtonBack onClick={() => navigate(-1)}>
        <IconWrapper>
          <FiChevronLeft />
        </IconWrapper>
        <ButtonBackContent>
          <FilterTitle>Provas</FilterTitle>
        </ButtonBackContent>
      </ButtonBack>

      <StepperWrapper
        steps={steps}
        currentStep={currentStep - 1}
      />
    </DashboardSidebar>
  );
}
